import React, { useCallback, useState } from 'react';
import useSWR from 'swr';
import { useDispatch } from 'react-redux';
import { Avatar, Menu, MenuItem, Typography, Box, Divider, ListItemIcon } from '@mui/material';
import { AccountBox, Logout } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

import { PATHS } from 'src/constants/config';
import { removeJWT } from 'src/store/slices/jwtTokenSlice';
import { userApi } from 'src/api/userApi';
import { useDecodedToken } from 'src/hooks/useDecodedToken';

const fetcher = () => userApi.getCurrentUserInfo();

const ProfileDropdown = (collapsed) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data } = useSWR('currentUser', fetcher);
  const userDetails = data || null;
  const { isExpert } = useDecodedToken();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleLogout = useCallback(async () => {
    dispatch(removeJWT());
    navigate(PATHS.AUTH.LOGIN.value);
    handleClose();
  }, [dispatch, navigate, handleClose]);

  const handleViewProfile = () => {
    navigate(PATHS.PROFILE.EDIT.value);
    handleClose();
  };

  return (
    <Box sx={{ ml: collapsed ? 1 : 2, mt: 1 }}>
      <Avatar onClick={isExpert ? null : handleMenu} src={userDetails?.avatar} style={{ cursor: 'pointer' }} />
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            width: 200,
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <Box sx={{ p: 2, mb: 1 }}>
          <Typography variant="body1">
            {userDetails?.firstName} {userDetails?.lastName}
          </Typography>
        </Box>
        <Divider />
        <MenuItem onClick={handleViewProfile} sx={{ px: 2, py: 1, mt: 1 }}>
          <ListItemIcon>
            <AccountBox />
          </ListItemIcon>
          Profile
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout} sx={{ px: 2, py: 1 }}>
          <ListItemIcon>
            <Logout />
          </ListItemIcon>
          Log out
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default ProfileDropdown;
